import { useState } from 'react';
import { KTCard } from '../../../../_metronic/helpers';
import { ToastTopLeft } from '../../components/ToastTopLeft';
import { PostModalState } from './posts-table/model';
import { FeedPostsTable } from './posts-table/ui';
import { PostModal } from './posts-modal/ui/PostModal'

export const FeedPostsPage = () => {
	const [openModal, setOpenModal] = useState<PostModalState | null>(null);
	const [showErrorToast, setShowErrorToast] = useState(false);

	const handleModalClose = () => {
		setOpenModal(null);
	};

	return (
		<KTCard className='w-100'>
			<FeedPostsTable openModal={openModal} setOpenModal={setOpenModal} />

      {openModal && (
				<PostModal
					openModal={openModal}
					handleModalClose={handleModalClose}
					setShowErrorToast={setShowErrorToast}
				/>
			)}

			<ToastTopLeft
				showToast={showErrorToast}
				setShowToast={setShowErrorToast}
				state='danger'
			/>
		</KTCard>
	);
};
